// src/components/navbar/Navbar.js — UPDATED WITH GLASS PANEL GROUP
import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { FaMoneyBillWave, FaSeedling, FaSignOutAlt } from "react-icons/fa";
import "./Navbar.css";

export default function Navbar({ onLogout }) {
    const location = useLocation();
    const navigate = useNavigate();

    const handleLogout = () => {
        try {
            if (onLogout && typeof onLogout === "function") onLogout();
            localStorage.removeItem("admin");
            localStorage.removeItem("authToken");
            navigate("/login", { replace: true });
        } catch (err) {
            console.error("Logout failed:", err);
        }
    };

    return (
        <nav className="glass-navbar fixed-top">
            <div className="container-fluid d-flex justify-content-between align-items-center px-4">
                {/* Brand */}
                <Link to="/" className="navbar-brand">
                    Uttam Kirana
                </Link>

                {/* Grouped Buttons — Floating Glass Panel */}
                <div className="nav-buttons-group">
                    <Link
                        to="/money"
                        className={`nav-link ${location.pathname === "/money" ? "active" : ""}`}
                    >
                        <FaMoneyBillWave className="me-2" />
                        Money
                    </Link>

                    <Link
                        to="/grain"
                        className={`nav-link ${location.pathname === "/grain" ? "active" : ""}`}
                    >
                        <FaSeedling className="me-2" />
                        Grain
                    </Link>

                    <button className="btn-logout" onClick={handleLogout}>
                        <FaSignOutAlt className="me-2" />
                        Logout
                    </button>
                </div>
            </div>
        </nav>
    );
}